export const BOOKING_STATUSES = {
  IS_AVAILABLE_VALIDATION: 'available',
  NOT_AVAILABLE_VALIDATION: 'notavailable',
  EMPTY_VALIDATION: 'empty',
  UNDEFINED_VALIDATION: 'undef'
};

export const DEFAULT_MONTHS = [
  'jan',
  'feb',
  'mar',
  'apr',
  'may',
  'jun',
  'jul',
  'aug',
  'sep',
  'oct',
  'nov',
  'dec'
];
export const CYCLING_TRANSPORT = 'bicycling';
export const DRIVING_TRANSPORT = 'driving';
export const TRANSIT_TRANSPORT = 'transit';
export const WALKING_TRANSPORT = 'walking';

export default {
  DEFAULT_MONTHS,
  CYCLING_TRANSPORT,
  DRIVING_TRANSPORT,
  TRANSIT_TRANSPORT,
  WALKING_TRANSPORT,
  BOOKING_STATUSES
};
